import axios from 'axios';
import * as actions from './actionsTypes';
import messages from '../../messages';
import UnidadNodeServices from './unidadNode.services';
import toastr from 'toastr';

export const getUnidadNodes = id => async dispatch => {
  try {
    dispatch({
      type: actions.LOADER_UNIDAD_NODES,
      payload: true
    });
    const resp = await UnidadNodeServices.getUnidadNode(id);
    const data = [];
    resp.data.hijos.map(item => {
      data.push({...item, state:true});
    });
    resp.data.no_hijos.map(item => {
      data.push({...item, state:false});
    });
    dispatch({
      type: actions.GET_UNIDAD_NODES,
      payload: data
    });
    dispatch({
      type: actions.UNIDAD_NODE_FAIL,
      payload: ''
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.UNIDAD_NODE_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADER_UNIDAD_NODES,
      payload: false
    });
  }
}

export const saveUnidadNode = (data, opt=null) => async dispatch => {
  try {
    if(opt){
      opt(true);
    }
    dispatch({
      type: actions.SAVE_LOADER_UNIDAD_NODE,
      payload: true
    });
    await UnidadNodeServices.saveUnidadNode(data);
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.UNIDAD_NODE_FORM_FAIL,
      payload: ''
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      switch (ex.response.status) {
        case 400:
          message = ex.response.data;
          break;
        case 404:
          message = messages.notFound;
        default:
          message = `${messages.errorMessage} ${ex.message}`;
          break;
      }
      // if(ex.response?.data){
      //   message = ex.response.data.message;
      // }else{
      //   message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      // }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.UNIDAD_NODE_FORM_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_UNIDAD_NODE,
      payload: false
    });
    if(opt){
      opt(false);
    }
  }
}

export const deleteUnidadNode = (data, opt=null) => async dispatch => {
  try {
    if(opt){
      opt(true);
    }
    dispatch({
      type: actions.SAVE_LOADER_UNIDAD_NODE,
      payload: true
    });
    await UnidadNodeServices.deleteUnidadNodew(data);
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    dispatch({
      type: actions.UNIDAD_NODE_FORM_FAIL,
      payload: ''
    });
  } catch (ex) {
  
    let message = '';
    if (axios.isAxiosError(ex)){
      switch (ex.response.status) {
        case 400:
          message = ex.response.data;
          break;
        case 404:
          message = messages.notFound;
        default:
          message = `${messages.errorMessage} ${ex.message}`;
          break;
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.UNIDAD_NODE_FORM_FAIL,
      payload: message
    });
  }finally{
    if(opt){
      opt(false);
    }
    dispatch({
      type: actions.SAVE_LOADER_UNIDAD_NODE,
      payload: false
    });
  }
}